export const globalActionTypes = {
  LOADING: 'global/LOADING',
};
